import { namespaceActions } from 'modules/redux-utils'
import { NAME } from './constants'

const LOAD_PERSONS = 'LOAD_PERSONS'
const SET_SELECTED_PERSONS = 'SET_SELECTED_PERSONS'

export default namespaceActions(NAME)([LOAD_PERSONS, SET_SELECTED_PERSONS])
